module.exports = __webpack_public_path__ + "img/_2.48ceeecb.png";